import { TApplicationState } from '../../types/redux';

export const selectFormAdditionalServices = (state: TApplicationState) => state.requestFormV2.quiz.additionalServices;
